import {
    getList
} from '@/api/card';



const state = {
    assignCards: []
}
const mutations = {
    ADD_CARD: (state, card) => {
        for (let key in state.assignCards) {
            if (state.assignCards[key].iccid == card.iccid) {
                return
            }
        }
        state.assignCards.push(card)
    },
    DEL_CARD: (state, card) => {
        state.assignCards.splice(state.assignCards.indexOf(card), 1)
    },
    CLEAR: (state) => {
        state.assignCards = []
    },
}


const actions = {
    add({ commit, state }, iccidRange) {
        return new Promise((resolve, reject) => {
            getList({
                start_card_no: iccidRange.start_card_no,
                end_card_no: iccidRange.end_card_no,
                page_size: 15000
            }).then(res => {
                if (res.code == 0) {
                    let cards = res.data.list.map(item => {
                        return {
                            iccid: item.iccid, mapping_number: item.mapping_number,
                        }
                    })
                    for (let key in cards) {
                        commit('ADD_CARD', cards[key])
                    }
                    resolve(cards)
                } else {
                    reject(res.msg)
                }
            })
        })
    }
}



export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/assigncard.js